import { createOverlay, Overlay } from './loaderOverlay';

export function configureTypeaheadAutocomplete(
    searchUrl: string,
    searchInput: JQuery<HTMLElement>,
    searchedResultInput: JQuery<HTMLElement> | undefined,
    display: string | ((obj: any) => string), 
    searchResultFieldName: string, 
    searchUrlParameterName: string,
    noResultsFound: () => void = () => {},
    templates: any | undefined = undefined
) {
    let searchInProgressOverlay: Overlay;
    searchInput.typeahead(
        {
            minLength: 1,
            highlight: true
        },
        {
            display: display,
            limit: Infinity,
            source(query: string, _, asyncResults) {
                setTimeout(() => {
                    if (query === searchInput.val() as string) {

                        searchInProgressOverlay.show();

                        $.get(searchUrl.replace(searchUrlParameterName, encodeURIComponent(query)), data => {
                            asyncResults!(data);

                            if (data.length === 0) {
                                noResultsFound();
                            }

                            searchInProgressOverlay.hide();
                        });
                    }
                }, 1000)
            },
            templates: templates
        }
    );

    const closestParentContainer = searchInput.closest("span");
    if (closestParentContainer.length !== 1) throw new Error("Typeahead search input is not wrapped in span.")
    searchInProgressOverlay = createOverlay(closestParentContainer[0]);

    searchInput.on("keyup", (event) => {
        if (searchedResultInput && $(event.currentTarget).val() !== searchInput.data("last-autocompleted-value")) {
            searchedResultInput.val("");
            searchedResultInput.valid();
        }
    });

    searchInput.on("typeahead:select typeahead:autocompleted", (e, data) => {
        searchInput.data("last-autocompleted-value", searchInput.val() as string);
        if (searchedResultInput) {
            searchedResultInput.val(data[searchResultFieldName]);
            searchedResultInput.valid();
        }
    });    
}

